import { isSettingPeriodValid } from "../search/search";
import { SETTING, SETTING_TYPE } from "./constants";

export const validateSettingCollectionFilter = isSettingPeriodValid;
export const validateSettingIsExists = (v) => !!v;

export const validateSettingType = (type, value) => {
  return !(
    (type === SETTING_TYPE.string && typeof value !== "string") ||
    (type === SETTING_TYPE.number && typeof value !== "number") ||
    (type === SETTING_TYPE.bool && typeof value !== "boolean") ||
    (type === SETTING_TYPE.array && !Array.isArray(value))
  );
};

export const SETTINGS_VALIDATORS = {
  [SETTING.collectionFilter.id]: validateSettingCollectionFilter,
  [SETTING.libraryLanguages.id]: validateSettingIsExists,
};
